import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { PermissionsTypes } from '@gem/call/Model/callPermissions/callPermissionsModel.types';
import { PERMISSIONS_TYPES_TRANSLATIONS } from '@gem/call/constants';
import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';
import { RadioLabel } from '@gem/ui-kit';

import { useCallChangeMemberPermissionPopupPresenter } from './CallChangeMemberPermissionPopup.presenter';
import styles from './CallChangeMemberPermissionPopup.styles.m.css';
import { ICallChangeMemberPermissionPopupProps } from './CallChangeMemberPermissionPopup.types';

const descriptionTranslations = {
  [PermissionsTypes.SwitchOnCamera]: 'call_user_can_switch_camera',
  [PermissionsTypes.SwitchOnMic]: 'call_user_can_switch_mic',
  [PermissionsTypes.ShareScreen]: 'call_user_can_share_screen',
};

export const CallChangeMemberPermissionPopup: FC<
  ICommonPopupsProps<ICallChangeMemberPermissionPopupProps>
> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useCallChangeMemberPermissionPopupPresenter(props);

  return (
    <Popup
      title={t(PERMISSIONS_TYPES_TRANSLATIONS[props.params!.permissionType])}
      isHidden={props.popupInstance.isHidden}
      isOpened
      handlePrevStep={presenter.goBack}
      onClose={presenter.onClose}
    >
      <div className={styles.title}>{t(descriptionTranslations[props.params!.permissionType])}</div>
      <div className={styles.wrapper}>
        {presenter.permissionValues.map((item) => (
          <RadioLabel {...item} />
        ))}
      </div>
    </Popup>
  );
});
